module.exports = __webpack_public_path__ + "img/yaoqm.0a39e463.png";